import { BaseService } from './base-service';
import {
	CreateSafetyAndHygieneResponsibleRequestDTO,
	CreateSafetyAndHygieneResponsibleResponseDTO,
	DestroySafetyAndHygieneResponsibleRequestDTO,
	DestroySafetyAndHygieneResponsibleResponseDTO,
	GetListSafetyAndHygieneResponsibleRequestDTO,
	GetListSafetyAndHygieneResponsibleResponseDTO,
	GetSafetyAndHygieneResponsibleRequestDTO,
	GetSafetyAndHygieneResponsibleResponseDTO,
	UpdateSafetyAndHygieneResponsibleRequestDTO,
	UpdateSafetyAndHygieneResponsibleResponseDTO
} from '@/core/dto';

export class SafetyAndHygieneResponsibleService extends BaseService<any> {
	private static instance: SafetyAndHygieneResponsibleService;

	private constructor(public readonly basePath: string = '/safety-and-hygiene-responsible') {
		super();
	}

	public static getInstance(): SafetyAndHygieneResponsibleService {
		if (!SafetyAndHygieneResponsibleService.instance) {
			SafetyAndHygieneResponsibleService.instance = new SafetyAndHygieneResponsibleService();
		}
		return SafetyAndHygieneResponsibleService.instance;
	}

	public async show(
		params: GetSafetyAndHygieneResponsibleRequestDTO
	): Promise<GetSafetyAndHygieneResponsibleResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().get<GetSafetyAndHygieneResponsibleResponseDTO>(url, { params });
		return data;
	}

	public async index(
		params: GetListSafetyAndHygieneResponsibleRequestDTO
	): Promise<GetListSafetyAndHygieneResponsibleResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await this.getInstance().get<GetListSafetyAndHygieneResponsibleResponseDTO>(url, { params });
		return data;
	}

	public async create(
		params: CreateSafetyAndHygieneResponsibleRequestDTO
	): Promise<CreateSafetyAndHygieneResponsibleResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await this.getInstance().post<CreateSafetyAndHygieneResponsibleResponseDTO>(url, params);
		return data;
	}

	public async update(
		params: UpdateSafetyAndHygieneResponsibleRequestDTO
	): Promise<UpdateSafetyAndHygieneResponsibleResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().put<UpdateSafetyAndHygieneResponsibleResponseDTO>(url, params);
		return data;
	}

	public async destroy(
		params: DestroySafetyAndHygieneResponsibleRequestDTO
	): Promise<DestroySafetyAndHygieneResponsibleResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().delete<DestroySafetyAndHygieneResponsibleResponseDTO>(url, {
			params
		});
		return data;
	}
}
